
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

import headImgScroll1 from '../images/headImgScroll1.jpeg';
import headImgScroll2 from '../images/headImgScroll2.jpeg';
import headImgScroll3 from '../images/headImgScroll3.jpeg';

const ImageSlider = () => {

  const slides = [headImgScroll1, headImgScroll2, headImgScroll3];

  return (
    <section style={{ width: '100%', backgroundColor: "red" }}>
      <Swiper
        effect="fade"
        autoplay={{ delay: 11000 }}
        pagination={{ clickable: true }}
        navigation
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        style={{ height: '100%' }}
      >

        {slides.map((img, index) => (
          <div
            style={{
              width: '100%',
              backgroundColor: "red"
            }}
          >
            <SwiperSlide key={index}>

              <img
                src={img}
                alt={`slide-${index}`}
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />

            </SwiperSlide>
          </div>
        ))}
      </Swiper>
    </section>
  );
};

export default ImageSlider;